import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import blog10 from "../../assets/images/blogs/10.png";
import scale from "../../assets/images/blogs/scale.png";
import virtual1 from "../../assets/images/blogs/virtual1.png";
import styles from "./styles";
import newblogimg from '../../assets/images/blogs/newblogimg.png'
import tax7 from "../../assets/images/blogs/tax7.png";

const RecentBlogs = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <div className="blog-container" style={styles.cardContainer}>
      <div className="pb-2 mb-5">
        <h3 className="text-center blog-title" style={styles.heading}>
          Insights from Boston Financial
        </h3>
      </div>

      <div style={styles.row}>
          {/* card1 */}
          <Link
            to="/decoding-india-consumption-boom"
            style={styles.card}
            onMouseEnter={() => setHovered(1)}
            onMouseLeave={() => setHovered(null)}
          >
            <div
              style={{
                ...styles.cardImage,
                backgroundImage: `url(${newblogimg})`,
              }}
            >
              <div
                className={`cardOverlay ${
                  hovered === 1 ? "overlayVisible" : ""
                }`}
                style={{
                  ...styles.cardOverlay1,
                  ...(hovered === 1 ? styles.overlayVisible : {}),
                }}
              ></div>
              <div style={styles.cardDateContainer}>
                <div style={styles.cardDate}>Feb 21, 2025</div>
                <div style={styles.cardDateLine}></div>
              </div>
              <div style={styles.cardTitle}>
              Decoding India's Consumption Boom: BFAG's Investment Approaches  
                <br />to the World's Fastest-Growing Major Economy
              </div>
            </div>
          </Link>
          {/* card1 */}

          {/* card2 */}
          <Link
            to="/virtual-cpa-services"
            style={styles.card}
            onMouseEnter={() => setHovered(2)}
            onMouseLeave={() => setHovered(null)}
          >
            <div
              style={{
                ...styles.cardImageSmall,
                backgroundImage: `url(${virtual1})`,
              }}
            >
              <div
                className={`cardOverlay ${
                  hovered === 2 ? "overlayVisible" : ""
                }`}
                style={{
                  ...styles.cardOverlay2,
                  ...(hovered === 2 ? styles.overlayVisible : {}),
                }}
              ></div>
              <div style={styles.cardDateContainer}>
                <div style={styles.cardDate}>Jan 14, 2025</div>
                <div style={styles.cardDateLine}></div>
              </div>
              <div style={styles.cardTitle2}>
              Virtual CPA Services: How to Maximize Your Business's
              <br /> Financial Health Remotely
              </div>
            </div>
          </Link>
          {/* card2 */}
        </div>

        <div style={styles.row}>
          {/* card3 */}
          <Link
            to="/cryptocurreny-taxes-explained"
            style={styles.card}
            onMouseEnter={() => setHovered(3)}
            onMouseLeave={() => setHovered(null)}
          >
            <div
              style={{
                ...styles.cardImageNoBorder,
                backgroundImage: `url(${tax7})`,
              }}
            >
              <div
                className={`cardOverlay ${
                  hovered === 3 ? "overlayVisible" : ""
                }`}
                style={{
                  ...styles.cardOverlay3,
                  ...(hovered === 3 ? styles.overlayVisible : {}),
                }}
              ></div>
              <div style={styles.cardDateContainer}>
                <div style={styles.cardDate}>Jan 5, 2025</div>
                <div style={styles.cardDateLine}></div>
              </div>
              <div style={styles.cardTitle}>
              Cryptocurrency Taxes Explained: <br /> A CPA’s Guide to
                Navigating the Digital Currency Landscape
              </div>
            </div>
          </Link>
          {/* card3 */}

          {/* card4 */}
          <Link
            to="/from-seed-to-scale"
            style={styles.card}
            onMouseEnter={() => setHovered(4)}
            onMouseLeave={() => setHovered(null)}
          >
            <div
              style={{
                ...styles.cardImageNoBorder4,
                backgroundImage: `url(${scale})`,
              }}
            >
              <div
                className={`cardOverlay ${
                  hovered === 4 ? "overlayVisible" : ""
                }`}
                style={{
                  ...styles.cardOverlay4,
                  ...(hovered === 4 ? styles.overlayVisible : {}),
                }}
              ></div>
              <div style={styles.cardDateContainer}>
                <div style={styles.cardDate}>Dec 30, 2024</div>
                <div style={styles.cardDateLine}></div>
              </div>
              <div style={styles.cardTitle}>
              From Seed to Scale:
                <br /> How Pune's CAs are Fuelling the City's Startup Ecosystem
              </div>
            </div>
          </Link>
          {/* card4 */}

          {/* card5 */}
          <Link
            to="/annual-inflation-adjustments"
            style={styles.card}
            onMouseEnter={() => setHovered(5)}
            onMouseLeave={() => setHovered(null)}
          >
            <div
              style={{
                ...styles.cardImageNoBorder5,
                backgroundImage: `url(${blog10})`,
              }}
            >
              <div
                className={`cardOverlay ${
                  hovered === 5 ? "overlayVisible" : ""
                }`}
                style={{
                  ...styles.cardOverlay5,
                  ...(hovered === 5 ? styles.overlayVisible : {}),
                }}
              ></div>
              <div style={styles.cardDateContainerOpposite}>
                <div style={styles.cardDateOpposite}>Dec 20, 2024</div>
                <div style={styles.cardDateLineOpposite}></div>
              </div>
              <div style={styles.cardTitle}>
              Annual Inflation Adjustments for Tax Year 2025: What Boston{" "}
              <br /> Taxpayers Should Know
              </div>
            </div>
          </Link>
          {/* card5 */}
        </div>
    </div>
  );
};

export default RecentBlogs;